parasails.registerPage('spotlightmanager', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    spotlightData: [
      {
        message: [{ message: "Message 1" }, { message: "Message 2" }],
        startDateTime: "2023-01-01",
        endDateTime: "2023-01-02",
        active: true
      }
    ],
    showModal: false,
    isEditing: false,
    currentRecord: {
      eventID: "",
      partID: "",
      partIndex: "",
      message: [{ message: "" }, { message: "" }],
      startDateTime: "",
      endDateTime: "",
      active: true
    },
    currentIndex: null,
    syncing: false,
    cloudError: '',
    formErrors: { /* … */ },
    // Pagination properties
    currentPage: 1,
    pageSize: 10,
    // Sorting properties
    sortKey: 'startDateTime',
    sortDirection: 'asc'
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    const urlParams = new URLSearchParams(window.location.search);
    this.eventID = urlParams.get('eventID');
    this.partID = urlParams.get('partID');
  },
  computed: {
    isSaveDisabled() {
      const hasMessage = this.currentRecord.message[0].message.trim() !== '' || this.currentRecord.message[1].message.trim() !== '';
      const hasStartDate = this.currentRecord.startDateTime !== '';
      const hasEndDate = this.currentRecord.endDateTime !== '';
  
      return !(hasMessage && hasStartDate && hasEndDate);
    },
    // Pagination computed properties
    sortedData: function() {
      // Create a copy of the data to avoid modifying the original
      const data = [...this.spotlightData];
      
      // Simple sort function that sorts by startDateTime first, then by endDateTime
      const sortedData = data.sort((a, b) => {
        // Primary sort by startDateTime
        const aStartDate = new Date(a.startDateTime);
        const bStartDate = new Date(b.startDateTime);
        
        // If startDateTime is the same, sort by endDateTime
        if (aStartDate.getTime() === bStartDate.getTime()) {
          const aEndDate = new Date(a.endDateTime);
          const bEndDate = new Date(b.endDateTime);
          
          if (this.sortDirection === 'asc') {
            return aEndDate - bEndDate;
          } else {
            return bEndDate - aEndDate;
          }
        }
        
        // Otherwise sort by startDateTime
        if (this.sortDirection === 'asc') {
          return aStartDate - bStartDate;
        } else {
          return bStartDate - aStartDate;
        }
      });
      
      // Update the original indices mapping after sorting
      this.updateOriginalIndices(sortedData);
      
      return sortedData;
    },
    
    paginatedData: function() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedData.slice(start, end);
    },
    
    totalPages: function() {
      return Math.ceil(this.sortedData.length / this.pageSize);
    },
    
    startIndex: function() {
      return (this.currentPage - 1) * this.pageSize;
    },
    
    endIndex: function() {
      return Math.min(this.startIndex + this.pageSize, this.sortedData.length);
    },
    
    displayedPages: function() {
      // Show a window of 5 pages centered around the current page
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      
      if (totalPages <= 5) {
        // If we have 5 or fewer pages, show all pages
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      }
      
      // Calculate the window of pages to display
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, startPage + 4);
      
      // Adjust if we're near the end
      if (endPage === totalPages) {
        startPage = Math.max(1, endPage - 4);
      }
      
      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    formatDate(isoDate) {
      const date = new Date(isoDate);
      return new Intl.DateTimeFormat('ja-JP', { year: 'numeric', month: 'long', day: 'numeric' }).format(date);
    },
    openModal(record = null, index = null) {
      this.showModal = true;
      if (record) {
        this.isEditing = true;
        this.currentRecord = JSON.parse(JSON.stringify(record));
        this.currentRecord.startDateTime = this.formatForInput(record.startDateTime);
        this.currentRecord.endDateTime = this.formatForInput(record.endDateTime);
        this.currentRecord.active = record.active;
        this.currentIndex = index;
        console.log("Editing record: ", JSON.stringify(this.currentRecord));
      } else {
        this.isEditing = false;
        this.currentRecord = {
          eventID: this.eventID,
          partID: this.partID,
          partIndex: 0,
          message: [{"lang": "jp", message: "" }, {"lang": "en", message: "" }],
          startDateTime: "",
          endDateTime: "",
          active: true
        };
        this.currentIndex = null;
        console.log("Adding record: ", JSON.stringify(this.currentRecord));
      }
    },
    closeModal() {
      this.showModal = false;
    },
    async saveRecord() {
      console.log("Should be saving new record " + JSON.stringify(this.currentRecord));

      if (this.isEditing) {
        try {
          var newEvent = await Cloud.spotlightUpdatae.with({
            id: this.currentRecord.id,
            eventID: this.currentRecord.eventID,
            partID: this.currentRecord.partID,
            partIndex: this.currentRecord.partIndex,
            message: [{"lang": "jp", message: this.currentRecord.message[0].message }, {"lang": "en", message: this.currentRecord.message[1].message }],
            startDateTime: this.convertToUTC(this.currentRecord.startDateTime),
            endDateTime: this.convertToUTC(this.currentRecord.endDateTime),
            active: this.currentRecord.active
          });
          //this.$set(this.spotlightData, this.currentIndex, this.currentRecord);
          const index = this.spotlightData.findIndex(record => record.id === this.currentRecord.id);
          if (index !== -1) {
            // Update the record at the found index
            this.$set(this.spotlightData, index, Object.assign({}, this.spotlightData[index], this.currentRecord));
            console.log("updated index " + index);
          } else {
            console.error('Record not found');
          }
        } catch(e) {
          console.error(e);
          this.cloudError = e;
          return;
        }
      } else {
        try {
          var newEvent = await Cloud.spotlightAdd.with({
            eventID: this.eventID,
            partID: (this.partID) ? this.partID : 'unknown',
            partIndex: 0,
            message: [{"lang": "jp", message: this.currentRecord.message[0].message }, {"lang": "en", message: this.currentRecord.message[1].message }],
            startDateTime: this.convertToUTC(this.currentRecord.startDateTime),
            endDateTime: this.convertToUTC(this.currentRecord.endDateTime),
            active: true
          });
          this.currentRecord = newEvent.newEvent;
        } catch(e) {
          console.log("Error: " + e);
          this.cloudError = e;
          return;
        }
        this.spotlightData.push(this.currentRecord);
      }
      this.closeModal();
    },
    async updateActive(id) {
      try {
        let updateData = this.spotlightData.filter(item => item.id === id);
        if (updateData.length > 0) {
          const record = updateData[0]; // Access the first matching record
          await Cloud.spotlightUpdatae.with({
            id: record.id,
            eventID: record.eventID,
            partID: record.partID,
            partIndex: record.partIndex,
            message: record.message,
            startDateTime: record.startDateTime,
            endDateTime: record.endDateTime,
            active: record.active
          });
        } else {
          console.error('Record not found');
        }
      } catch(e) {
        console.log("Error: " + e);
        this.cloudError = e;
        return;
      }
    },
    handleParsing: function() {
      // Clear out any pre-existing error messages.
      this.formErrors = {};

      var argins = this.addEventFormData;

      // If there were any issues, they've already now been communicated to the user,
      // so simply return undefined.  (This signifies that the submission should be
      // cancelled.)
      if (Object.keys(this.formErrors).length > 0) {
        return;
      }

      return _.omit(argins, []);
    },
    confirnmDelete(id) {
      if (confirm("Are you sure you want to delete this message?")) {
        this.deleteRecord(id);
      }
    },
    async deleteRecord(id) {
      console.log("Should be deleting record " + id);
      try {
        console.log("removing " + id);
        var newEvent = await Cloud.spotlightDelete.with({
          id: id
        });
        this.spotlightData = this.spotlightData.filter(item => item.id !== id);
      } catch(e) {
        console.log("Error: " + e);
        this.cloudError = e;
        return;
      }
    },
    formatForInput(isoDate) {
      const date = new Date(isoDate);
      return date.toISOString().split('T')[0];
    },
    convertToUTC(dateString) {
      const date = new Date(dateString);
      return date.toISOString(); // Converts to UTC format
    },
    isCurrentDateInRange(startDateTime, endDateTime) {
      const currentDate = new Date();
      const start = new Date(startDateTime);
      const end = new Date(endDateTime);
      currentDate.setHours(0, 0, 0, 0);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      return currentDate >= start && currentDate <= end;
    },
    sortBy: function(key) {
      // If clicking the same column, toggle direction
      if (this.sortKey === key) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // If clicking a different column, set it as the sort key and default to ascending
        this.sortKey = key;
        this.sortDirection = 'asc';
      }
      
      // Reset to first page when sorting changes
      this.currentPage = 1;
    },
    getSortIconClass: function(key) {
      if (this.sortKey === key) {
        // If this column is the current sort key, show the appropriate direction icon
        return this.sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
      }
      // For columns that aren't being sorted, show the neutral sort icon
      return 'fa-sort';
    },
    // Method to update the original indices mapping
    updateOriginalIndices: function(sortedData) {
      // If sortedData is not provided, use the current spotlightData
      const dataToMap = sortedData || this.spotlightData;
      
      // Create a map of sorted indices to original indices
      this.originalIndices = dataToMap.map((item, index) => {
        // Find the original index of this item in the spotlightData array
        const originalIndex = this.spotlightData.findIndex(original => {
          // Use ID if available, otherwise compare the entire object
          if (item.id && original.id) {
            return item.id === original.id;
          }
          return JSON.stringify(item) === JSON.stringify(original);
        });
        return originalIndex;
      });
    },
  }
});
